const IconsToolIcon = ({ isActive, size = "24px", isMainPanel }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";
  // The toolbar (island) version reads thicker than its neighbours at the
  // same size; thin the strokes specifically for that placement.
  const strokeWidth = isMainPanel ? 1.4 : 2;

  return (
    <svg width={size} height={size} viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12.1006" cy="12.7705" r="9" stroke={finalColor} strokeWidth={strokeWidth} fill="none" />
      <path
        d="M9.10059 15.7705C9.10059 15.7705 10.6006 16.7705 12.1006 16.7705C13.6006 16.7705 15.1006 15.7705 15.1006 15.7705"
        stroke={finalColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path d="M9.60059 10.2705V12.7705" stroke={finalColor} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M14.6006 10.2705V12.7705" stroke={finalColor} strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  );
};

export default IconsToolIcon;
